import React__default, { useCallback } from 'react';
import PT from 'prop-types';
import { D as Dropdown } from '../../Dropdown/Dropdown-BVDSKlZi.js';
import { D as DropdownItem } from '../../Dropdown/DropdownItem/DropdownItem-BwO7oFG3.js';

function parseToNum(strToParse) {
  const parsed = parseInt(strToParse, 10);
  if (isNaN(parsed)) return 0;
  return parsed;
}
const PaginationDropdown = props => {
  const {
    id,
    currentSize,
    disabled,
    pageSizes,
    onSetPageSize,
    renderPaginationDropdownLabel
  } = props;
  const handleOverrideLabel = useCallback(label => renderPaginationDropdownLabel === null || renderPaginationDropdownLabel === void 0 ? void 0 : renderPaginationDropdownLabel(parseToNum(label)), [renderPaginationDropdownLabel]);
  const handleSetPageSize = useCallback(pageSize => onSetPageSize(parseToNum(pageSize)), [onSetPageSize]);
  return /*#__PURE__*/React__default.createElement(Dropdown, {
    id: id,
    disabled: disabled,
    selectedValue: currentSize.toString(),
    onChange: handleSetPageSize,
    onOverrideLabel: handleOverrideLabel
  }, pageSizes.map(pageSize => /*#__PURE__*/React__default.createElement(DropdownItem, {
    id: `${id}-${pageSize}`,
    key: pageSize.toString(),
    value: pageSize.toString()
  }, pageSize)));
};
PaginationDropdown.propTypes = {
  /**
   * The id assigned to the interactive element.
   * DropdownItem will be assigned {id}-{pagesize}.
   */
  id: PT.string.isRequired,
  /**
  * The current page size.
  */
  currentSize: PT.number.isRequired,
  /**
  * The page sizes that the user can select from.
  */
  pageSizes: PT.arrayOf(PT.number.isRequired).isRequired,
  /**
  * onChange handler for changing the page size.
  */
  onSetPageSize: PT.func.isRequired,
  /**
  * The text that displays on the dropdown.
  */
  renderPaginationDropdownLabel: PT.func,
  /**
   * Specifies if the control is disabled, which prevents the user
   * from modifying the page size. A disabled control can't receive focus.
   */
  disabled: PT.bool
};
PaginationDropdown.defaultProps = {
  renderPaginationDropdownLabel: pageSize => `${pageSize}`,
  disabled: false
};

export { PaginationDropdown as P };
//# sourceMappingURL=PaginationDropdown-dNd-5TAu.js.map
